"use client";

import { useMedia } from "@/hooks/useMedia";
import { MOBILE_QUERY } from "@/hooks/breakpoints";
import WhyDev48Mobile from "./WhyDev48Mobile";
import WhyDev48Desktop from "./WhyDev48Desktop";

export default function WhyDev48() {
  const mobile = useMedia(MOBILE_QUERY);
  return mobile ? <WhyDev48Mobile /> : <WhyDev48Desktop />;
}
